<template lang='pug'>
  .pa-2.text-caption.font-weight-light(:class='logClass')
    span.text-subtitle-1.font-weight-light Test Logs
    div(v-for='log in test.logs' v-html='log')
</template>

<script>
export default {
  name: 'BionicMetricsTestLogs',
  props: {
    test: {
      type: Object,
      required: true
    }
  },
  computed: {
    logClass() {
      if (this.$vuetify.theme.dark) return 'dark';
      return 'grey lighten-4';
    }
  }
};
</script>

<style scoped>
.dark {
  background-color: #222222;
}
.light {
  background-color: #ffcdd2;
}
</style>
